module.exports = __webpack_public_path__ + "static/media/hr.6bc851f3.svg";